import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Panel, Spinner, Button} from 'shared/components';
import {useFetchModel} from 'shared/hooks';
import {endpoints, types} from 'main/tools';
import {CustomCalendarEvent} from 'main/stores/custom_calendar_events';

const CustomEventDetails = observer(({uiState, event}) => {
  const [customEvent, isLoading] = useFetchModel(
    endpoints.CUSTOM_CALENDAR_EVENTS.with(event.extendedProps.customEventId),
    types.CUSTOM_CALENDAR_EVENT,
    CustomCalendarEvent
  );

  if (isLoading) return <Spinner/>;

  return (
    <div>
      <Panel.Header title={customEvent.dateRange}/>
      <Panel.Separator/>
      {customEvent.description &&
        <div className='whitespace-pre-line'>{customEvent.description}</div>}
      <div className='mt3 empty:hidden'>
        {customEvent.canPatch &&
          <Button
            trait='default'
            className='mr1'
            onClick={() => {
              uiState.closeEventDetailsModal();
              uiState.openEditCustomEventModal(customEvent);
            }}
          >
            <FormattedMessage id='calendar.custom_events.Edit'/>
          </Button>}
        {customEvent.canDelete &&
          <Button trait='destructive' onClick={() => uiState.destroyCustomEvent(customEvent)}>
            <FormattedMessage id='calendar.custom_events.Delete'/>
          </Button>}
      </div>
    </div>
  );
});

export default CustomEventDetails;
